import { ZuweisungDetailsComponent } from './zuweisung-details/zuweisung-details.component';
import { AufgabeDetailsComponent } from './aufgabe-details/aufgabe-details.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AufgabenDashboardComponent } from './aufgaben-dashboard/aufgaben-dashboard.component';

export const aufgabenRoutes: Routes = [

    {
        path: '',
        component: AufgabenDashboardComponent,
    },
    {
        path: 'details/:id',
        component: AufgabeDetailsComponent,
    },
    {
        path: 'zuweisung/:id',
        component: ZuweisungDetailsComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(aufgabenRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class AufgabenmRoutingModule {
}
